import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../../Layout/PageLayout";
import { EmailSubscriptionWidget } from "@/components/Site/EmailSubscriptionWidget/EmailSubscriptionWidget";
import {
  CANONICAL_HOST,
  generateEventsComingSoonMetaTags,
  injectJsonLd,
  removeJsonLd,
  updateDocumentHead,
} from "@/utils/seoUtils";
import eventsHeroImage from "@/assets/events-hero-foraging.png";
import "./EventsPage.css";
import "./EventsComingSoonPage.css";

const EventsComingSoonPage: React.FC = () => {
  useEffect(() => {
    updateDocumentHead(generateEventsComingSoonMetaTags());

    injectJsonLd(
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: CANONICAL_HOST,
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Experiences",
            item: `${CANONICAL_HOST}/events`,
          },
        ],
      },
      "events-coming-soon-breadcrumb",
    );

    return () => removeJsonLd("events-coming-soon-breadcrumb");
  }, []);

  return (
    <PageLayout className="events-page events-page--coming-soon" useContainer={false}>
      <div className="events-page__main-column">
        <section
          className="events-hero events-coming-soon__hero"
          aria-labelledby="events-coming-soon-heading"
        >
          <div className="events-hero__cover">
            <img
              src={eventsHeroImage}
              alt=""
              className="events-hero__cover-image"
              width={768}
              height={1024}
              decoding="async"
              fetchPriority="high"
            />
            <div className="events-hero__scrim" aria-hidden />
          </div>
          <div className="events-hero__inner">
            <div className="events-hero__content">
              <p className="events-coming-soon__eyebrow">Adventures</p>
              <h1
                id="events-coming-soon-heading"
                className="hero-headline events-hero__headline"
              >
                Experiences are coming.
              </h1>
              <p className="hero-subtext events-hero__subtext">
              Guided walks, workshops, and field outings led by people who know the land. 
              Small groups, real places, all skill levels.
              Explore maps and the field guide while we finish building the calendar.
              </p>
              <div className="events-hero__ctas">
                <Link
                  to="/maps"
                  className="events-hero__cta landing-hero-cta btn-primary"
                >
                  Explore Maps
                </Link>
                <Link
                  to="/field-guide"
                  className="events-hero__cta landing-hero-cta events-hero__cta--secondary"
                >
                  Open field guide
                </Link>
              </div>
            </div>
          </div>
        </section>

        <EmailSubscriptionWidget
          idPrefix="events-coming-soon-alerts"
          eyebrow="FIELD ALERTS"
          headline="Be first in line."
          description="Seasonal updates, new adventures, and foraging news—no spam."
          successMessage="You're on the list. We'll be in touch."
          emailInputAriaLabel="Email for experiences and field alerts"
        />
      </div>
    </PageLayout>
  );
};

export default EventsComingSoonPage;
